import { Button, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CreateProductModal from "../../../components/Modal/CreateProduct/CreateProductModal";
import { Context } from "../../../context/context";
import {
  editCompanieValues,
  getCompanyById,
} from "../../../services/company-service";
import { getProductByCompanyId } from "../../../services/product-service";

import "./CompanyById.scss";

export default function CompanyById() {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const [companyData, setCompanyData] = useState({});
  const [name, setName] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [uf, setUf] = useState("");
  const [productComission, setProductComission] = useState("");
  const [icms, setIcms] = useState("");
  const [kmCost, setKmCost] = useState("");
  const [departureCost, setDepartureCost] = useState("");
  const [products, setProducts] = useState([1]);
  const [kFilial, setKFilial] = useState("");
  const [kFilialArla, setKFilialArla] = useState("");
  const [productsValues, setProductsValues] = useState({ products });

  const submitNewK = async (e) => {
    e.preventDefault();
    const newData = {
      ...companyData,
      k_filial: kFilial,
      k_filial_arla: kFilialArla,
    };
    try {
      const response = await editCompanieValues(accessToken, newData);
      console.log(response);
      alert("K da filial atualizado com sucesso.");
    } catch {
      return alert("Algo deu errado, tente novamente.");
    }
  };

  async function getCompanyData() {
    try {
      const data = await getCompanyById(accessToken, id);
      const products = await getProductByCompanyId(accessToken, id);

      setCompanyData(data);
      setName(data.name);
      setCnpj(data.cnpj);
      setUf(data.state_id);
      setProductComission(data.comissao_produto);
      setIcms(data.icms);
      setKmCost(data.custo_km);
      setDepartureCost(data.custo_partida);
      setProducts(products);
      setProductsValues({ products });
      setKFilial(data.k_filial);
      setKFilialArla(data.k_filial_arla);
      return;
    } catch (error) {
      alert("Falha ao buscar dados da emrpesa");
    }
  }

  useEffect(() => {
    getCompanyData();
  }, []);

  return (
    <>
      {open ? (
        <CreateProductModal
          open={open}
          setOpen={setOpen}
          id={id}
          products={products}
        />
      ) : (
        ""
      )}
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Dados da Empresa</h1>
        <div className="inputs-container">
          <div className="inputs-container__name-cnpj">
            <TextField
              fullWidth
              label="Nome"
              name="name"
              value={name}
              disabled
            />
            <TextField
              fullWidth
              label="Cnpj"
              name="cnpj"
              value={cnpj}
              disabled
            />
            <TextField fullWidth label="Estado" name="uf" value={uf} disabled />
          </div>

          <div className="inputs-container__costs">
            {/* <TextField
              label="Comissao Produto"
              name="comissao_produto"
              value={productComission}
              fullWidth
              onChange={(e) => setProductComission(e.target.value)}
              type="number"
              disabled
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            /> */}

            <TextField
              label="K Filial Diesel"
              name="k_filial"
              fullWidth
              value={kFilial}
              type="number"
              onChange={(e) => setKFilial(e.target.value)}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />

            <TextField
              label="K Filial Arla"
              name="k_filial_arla"
              fullWidth
              value={kFilialArla}
              type="number"
              onChange={(e) => setKFilialArla(e.target.value)}
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />

            <TextField
              label="Custo de Km"
              name="custo_km"
              fullWidth
              value={kmCost}
              onChange={(e) => setKmCost(e.target.value)}
              type="number"
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
              disabled
            />

            <TextField
              label="Custo de Partida"
              name="custo_partida"
              fullWidth
              value={departureCost}
              onChange={(e) => setDepartureCost(e.target.value)}
              type="number"
              disabled
              inputProps={{
                autoComplete: "off",
                step: "0.0001",
              }}
            />
          </div>

          <div className="inputs-container__products">
            {products.length === 0 ? (
              <div className="inputs-container__products__new_product">
                <p>Nenhum produto encontrado.</p>
              </div>
            ) : (
              <div className="center-products">
                <p>Produtos Cadastrados</p>
                <div className="products">
                  {products.map((product) => {
                    return (
                      <div className="products__card">
                        <p>{product.name}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <Button
              size="medium"
              style={{ width: "250px", marginTop: "20px" }}
              variant="contained"
              onClick={() => setOpen(true)}
            >
              Novo produto
            </Button>
            <Button
              size="medium"
              style={{ width: "250px", marginTop: "20px", marginLeft: "20px" }}
              variant="contained"
              onClick={submitNewK}
            >
              Atualizar K da Filial
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}
